import { render } from "./BrandStory.vue?vue&type=template&id=69fb7620"
import script from "./BrandStory.vue?vue&type=script&lang=js"
export * from "./BrandStory.vue?vue&type=script&lang=js"

import "./BrandStory.vue?vue&type=style&index=0&id=69fb7620&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__